import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export const SUBMIT_VIDEO_REMINDER_STORAGE_KEY = 'submitVideoReminderDismissed';
export const PENDING_SUBMIT_VIDEO_REMINDER_STORAGE_KEY = 'pendingSubmitVideoReminderActivityId';
const SUBMIT_VIDEO_REMINDER_GRAPHIC_PATH = 'https://staticassets.goreact.com/submit-video-reminder.svg';

export interface SubmitVideoReminderDialogData {
	dialogTitleId?: string;
}

@Component({
	selector: 'submit-video-reminder-dialog',
	templateUrl: './submit-video-reminder-dialog.component.html',
	styleUrls: ['./submit-video-reminder-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		MatCheckboxModule,
		TranslateModule
	]
})
export class SubmitVideoReminderDialogComponent {
	public readonly graphicSrc = SUBMIT_VIDEO_REMINDER_GRAPHIC_PATH;
	public dontShowAgain = false;

	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<SubmitVideoReminderDialogData>
	): MatDialogRef<SubmitVideoReminderDialogComponent, void> {
		const dialogTitleId = config?.data?.dialogTitleId ?? SubmitVideoReminderDialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, SubmitVideoReminderDialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId,
			width: '379px',
			maxWidth: 'calc(100vw - 32px)'
		});
	}

	public static isDismissed (): boolean {
		return localStorage.getItem(SUBMIT_VIDEO_REMINDER_STORAGE_KEY) === 'true';
	}

	private static getDialogTitleId (): string {
		return `submit-video-reminder-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	public constructor (
		private dialogRef: MatDialogRef<SubmitVideoReminderDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: SubmitVideoReminderDialogData
	) {
		this.dialogRef.disableClose = true;
		this.data.dialogTitleId ??= SubmitVideoReminderDialogComponent.getDialogTitleId();
	}

	public close (): void {
		this.rememberPreference();
		this.dialogRef.close();
	}

	private rememberPreference (): void {
		if (this.dontShowAgain) {
			localStorage.setItem(SUBMIT_VIDEO_REMINDER_STORAGE_KEY, 'true');
		}
	}
}
